import { Box } from "@mui/material";

// const TerminosYCondicionesSeguro = () => {
//   return (
//     <Box className='tyc-insurance' sx={styles.root} onPointerMove={(e) => e.preventDefault()}>
//       <section>
//         <h3>Identificación de la empresa y datos de contacto:</h3>
//         <p>Zurich Santander Seguros Uruguay S.A. Teléfono de contacto: 2480 0800</p>
//         <p>Dirección: Av. Dr. Américo Ricaldoni 2509</p>
//         <h3>Descripción del producto:</h3>
//         <p>Póliza de Seguro Personal Básico Nº 125/COL/1125</p>
//         <h3>Información sobre responsabilidad:</h3>
//         <p>La responsabilidad del Asegurador está limitada, por cada una de las coberturas y por cada certificado de incorporación, a los límites anuales y sublímites por eventos, en caso de existir, señalados en las Condiciones Particulares. Dichos límites y sublímites se indicarán, asimismo, en el Certificado de Incorporación.</p>
//         <h3>Resumen Coberturas:</h3>
//         <p>La compañía brindará cobertura, con los siguientes límites agregados anuales:</p>
//         <ul>
//           <li>Cuentas Bancarias y Tarjetas: $100.000</li>
//           <li>Extracciones de Dinero: $5.000</li>
//         </ul>
//         <h4>Coberturas Adicionales:</h4>
//         <ul>
//           <li>Cobertura Bolso Protegido (incluye Equipos Electrónicos): $25.000 en el agregado anual</li>
//           <li>Cobertura Reembolso de Gastos: $10.000 en el agregado anual</li>
//         </ul>
//         <h3>Ajuste premios y coberturas:</h3>
//         <p>En los meses de diciembre los premios y las sumas aseguradas se ajustarán por la variación del IPC anual correspondiente al año inmediatamente anterior.</p>
//         <h3>Desistimiento:</h3>
//         <p>La cobertura individual de cada Asegurado finalizará en los siguientes casos, entre otros:</p>
//         <ol type="a">
//           <li>Al quedar extinguida la relación contractual entre el Tomador y el Asegurado en relación a la Cuenta y/o Tarjeta.</li>
//           <li>Por falta de pago del premio.</li>
//           <li>El tomador podrá rescindir el contrato de seguro en cualquier tiempo, sin expresión de causa, siempre que lo comunique fehacientemente al asegurador con una antelación de un mes.</li>
//         </ol>
//         <h3>Renovación anual:</h3>
//         <p>El Certificado de Incorporación será renovado automáticamente, siempre y cuando el asegurado abone los premios en la forma establecida en las Condiciones Generales.</p>
//         <strong>Al aceptar estos términos y condiciones autorizo a Banco Santander S.A a debitar los importes que se generan mensualmente a mi cargo por el seguro contratado. Asimismo, en caso de que no se permita efectuar el débito, autorizo a que el mismo se realice contra cualquier otro medio de pago activo que tenga contratado con Banco Santander S.A.</strong>
//         <h3>Condiciones Generales:</h3>
//         <p>Las Condiciones Generales y Particulares de la póliza se encuentran a su disposición en la página web del Banco Santander y la página web de Zurich Santander Seguros Uruguay.</p>
//       </section>
//     </Box>
//   );
// };

// Condiciones para el seguro PILOTO - A activar cuando negocios lo requiera
const TerminosYCondicionesSeguro = () => {
  return (
    <Box className='tyc-insurance' sx={styles.root} onPointerMove={(e) => e.preventDefault()}>
      <section>
        <h3>Identificación de la empresa y datos de contacto</h3>
        <p>Zurich Santander Seguros Uruguay S.A. Teléfono de contacto: 2480 0800.</p>
        <p>Dirección: Av. Dr. Américo Ricaldoni 2509</p>
        <h3>Descripción del producto</h3>
        <p>Póliza de Seguro Personal Nº 43/COL/0317</p>
        <h3>Información sobre responsabilidad</h3>
        <p>La responsabilidad del Asegurador está limitada, por cada una de las coberturas y por cada certificado de incorporación, a los límites anuales y sublímites por eventos, en caso de existir, señalados en las Condiciones Particulares. Dichos límites y sublímites se indicarán, asimismo, en el Certificado de Incorporación.</p>
        <h3>Resumen Coberturas:</h3>
        <p>La compañía brindara cobertura, con los siguientes límites agregados anuales:</p>
        <ul>
          <li>Cuentas Bancarias y Tarjetas de Crédito $ 672.700</li>
          <li>Extracciones de Dinero $ 60.225</li>
        </ul>
        <h4>Coberturas Adicionales:</h4>
        <ul>
          <li>Cobertura Compra Protegida $ 71.075 en el agregado anual</li>
          <li>Cobertura Bolso Protegido (incluye Equipos Electrónicos) $ 43.750 en el agregado anual</li>
          <li>Cobertura Reembolso de Gastos $ 17.000 en el agregado anual</li>
          <li>Cobertura Reembolso de Gastos por Traslados $13.950 en el agregado anual</li>
          <li>Cobertura Reembolso de Gastos Médicos $13.950 en el agregado anual</li>
          <li>Cobertura de Accidentes Personales por Hurto/Rapiña $2.023.300</li>
        </ul>
        <h3>Ajuste premios y coberturas</h3>
        <p>En los meses de diciembre los premios y las sumas aseguradas se ajustarán por la variación del IPC anual correspondiente al año inmediatamente anterior.</p>
        <h3>Desistimiento</h3>
        <p>La cobertura individual de cada Asegurado finalizará en los siguientes casos, entre otros:</p>
        <ol type="a">
          <li>Al quedar extinguida la relación contractual entre el Tomador y el Asegurado en relación a la Cuenta y/o Tarjeta.</li>
          <li>Por falta de pago del premio</li>
          <li>El tomador podrá rescindir el contrato de seguro en cualquier tiempo, sin expresión de causa, siempre que lo comunique fehacientemente al asegurador con una antelación de un mes.</li>
        </ol>
        <h3>Renovación anual</h3>
        <p>El Certificado de Incorporación será renovado automáticamente, siempre y cuando el asegurado abone los premios en la forma establecida en las Condiciones Generales.</p>
        <strong>Al aceptar estos términos y condiciones autorizo a Banco Santander S.A a debitar los importes que se generan mensualmente a mi cargo por el seguro contratado. Asimismo, en caso de que no se permita efectuar el débito, autorizo a que el mismo se realice contra cualquier otro medio de pago activo que tenga contratado con Banco Santander S.A.</strong>
        <h3>Condiciones Generales</h3>
        <p>Las Condiciones Generales y Particulares de la póliza se encuentran a su disposición en la página web del Banco Santander y la página web de Zurich Santander Seguros Uruguay.</p>
      </section>
    </Box>
  );
};

export default TerminosYCondicionesSeguro;

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    overflow: "scroll",

    ">*": {
      fontFamily: "body2.fontFamily",
      color: "#444444",
      paddingRight: "0.5rem",
      paddingLeft: "0.5rem",
      marginBottom: "0.5rem",
      marginTop: "0.5rem",
      alignSelf: "flex-start",
    },

    "section": {
      paddingBottom: "0",
      paddingTop: "0",
    },
  },
};
